import {FC} from "react";
import {useOperationalEntity} from "../../../context";
import "../../../../entities/overview/DetailsColumnHeader.scss";
import {Flag} from "@interstate/components/Flag";
import {LockClosedIcon} from "@interstate/components/Icons";
import {EntityStatus} from "@common-core/coat-operational-hierarchy-appsync-model";
import {useTranslation} from "react-i18next";

export const OperationalDetailsHeaderV2: FC = () => {
  const {t} = useTranslation();
  const {
    entity: {id, statuses}
  } = useOperationalEntity();

  return (
    <header
      id={`operational-details-header-${id}`}
      data-testid={`operational-details-header-${id}`}
      className={"details-column-header"}>
      <hgroup className={"details-column-header-group"}>
        <h3>{t("entity-detail.dealer.details")}</h3>
        {statuses?.includes(EntityStatus.PROTECTED) && (
          <aside className={"entity-card-header-callout"}>
            <Flag
              id={id}
              data-testid={id}
              variant={"info"}
              startIcon={<LockClosedIcon />}>
              Protected
            </Flag>
          </aside>
        )}
      </hgroup>
    </header>
  );
};
